jQuery(function ($) {
  //Locatie page btn #
  $("#btn-ervaren").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $("#begane-grond").offset().top,
      },
      500
    );
  });

  $("#btn-doen").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $("#1e-etage").offset().top,
      },
      500
    );
  });

  //Quote slick caraousel

  $(".quote-carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
  });

  $(".prev-btn-quote").click(function () {
    $(".quote-carousel").slick("slickPrev");
  });

  $(".next-btn-quote").click(function () {
    $(".quote-carousel").slick("slickNext");
  });
  $(".prev-btn-quote").addClass("slick-disabled");
  $(".quote-carousel").on("afterChange", function () {
    if ($(".quote-carousel .slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn-quote").addClass("slick-disabled");
    } else {
      $(".prev-btn-quote").removeClass("slick-disabled");
    }
    if ($(".quote-carousel .slick-next").hasClass("slick-disabled")) {
      $(".next-btn-quote").addClass("slick-disabled");
    } else {
      $(".next-btn-quote").removeClass("slick-disabled");
    }
  });

  //Photo Gallery slick caraousel

  $(".gallery-carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
  });

  $(".prev-btn-gallery").click(function () {
    $(".gallery-carousel").slick("slickPrev");
  });

  $(".next-btn-gallery").click(function () {
    $(".gallery-carousel").slick("slickNext");
  });
  $(".prev-btn-gallery").addClass("slick-disabled");
  $(".gallery-carousel").on("afterChange", function () {
    if ($(".gallery-carousel .slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn-gallery").addClass("slick-disabled");
    } else {
      $(".prev-btn-gallery").removeClass("slick-disabled");
    }
    if ($(".gallery-carousel .slick-next").hasClass("slick-disabled")) {
      $(".next-btn-gallery").addClass("slick-disabled");
    } else {
      $(".next-btn-gallery").removeClass("slick-disabled");
    }
  });

  // Netwerk page pill half button

  const mapView = document.getElementById("mapView");
  const listView = document.getElementById("listView");
  const divMap = document.getElementById("netwerk-map");
  const divList = document.getElementById("netwerk-list");

  $(mapView).click(function () {
    $(divMap).fadeIn(300); // Fade in div1 with a duration of 500 milliseconds
    $(divList).fadeOut(300); // Fade out div2 with a duration of 500 milliseconds
  });

  $(listView).click(function () {
    $(divMap).fadeOut(300); // Fade out div1 with a duration of 500 milliseconds
    $(divList).fadeIn(300); // Fade in div2 with a duration of 500 milliseconds
  });


  // Load More article

  $(".contentArticle").slice(0, 4).show();
  if ($(".contentArticle").length <= 4) {
    $("#loadMoreArticle").addClass("hidden");
  }
  $("#loadMoreArticle").on("click", function (e) {
    e.preventDefault();
    $(".contentArticle:hidden").slice(0, 4).slideDown(800);
    if ($(".contentArticle:hidden").length == 0) {
      // $("#loadMore").text("No Content").addClass("noContent");
      $("#loadMoreArticle").addClass("hidden");
    }
  });

  // Load More kennisdok

  $(".contentKennisdok").slice(0, 6).show();
  if ($(".contentKennisdok").length <= 6) {
    $("#loadMoreKennisdok").addClass("hidden");
  }
  $("#loadMoreKennisdok").on("click", function (e) {
    e.preventDefault();
    $(".contentKennisdok:hidden").slice(0, 6).slideDown(800);
    if ($(".contentKennisdok:hidden").length == 0) {
      $("#loadMoreKennisdok").addClass("hidden");
    }
  });

  // User profile page pill half button

  const myEvent = document.getElementById("myEvent");
  const myProfile = document.getElementById("myProfile");
  const divEvent = document.getElementById("my-event");
  const divProfile = document.getElementById("my-profile");

  $(myEvent).click(function () {
    $(divEvent).fadeIn(300);
    $(divProfile).fadeOut(300);
    $(myEvent).addClass("button-active");
    $(myProfile).removeClass("button-active");
  });

  $(myProfile).click(function () {
    $(divEvent).fadeOut(300);
    $(divProfile).fadeIn(300);
    $(myEvent).removeClass("button-active");
    $(myProfile).addClass("button-active");
  });

  //home title hero

  if (document.getElementById("variant-colour")) {
    var theDIV = document.querySelector(".variant-colour");
    var variantColour = theDIV.getAttribute("data-variant");

    var heroGrid = document.querySelector(".hero-grid");
    var heroImages = heroGrid.querySelectorAll("img");

    var heroText = document.querySelector(".hero-grid");
    var heroBtn = document.querySelector(".hero-btn");

    if (variantColour === "black") {
      heroImages.forEach(function (image) {
        image.classList.add("hero-title-black");
      });
      heroText.classList.add("text-black");
      heroBtn.classList.add("hero-btn-black");
    } else if (variantColour === "white") {
      heroImages.forEach(function (image) {
        image.classList.add("hero-title-white");
      });
      heroText.classList.add("text-white");
      heroBtn.classList.add("hero-btn-white");
    } else {
    }
  }

  //instagram
  const instaElement = document.getElementById("insta");

  fetch("https://feeds.behold.so/IbZKbdjGjpppX8UTaJKK")
    .then((response) => response.json())
    .then((data) => {
      let carouselItems = "";

      data.forEach((item) => {
        let slideContent = "";

        if (item.mediaType === "IMAGE" && item.mediaUrl) {
          slideContent = `
            <a href="${item.permalink}" target="_blank">
              <img src="${item.mediaUrl}" alt="${item.caption}" />
            </a>
          `;
        } else if (item.mediaType === "CAROUSEL_ALBUM") {
          const firstChild = item.children?.[0];
          if (
            firstChild &&
            firstChild.mediaType === "IMAGE" &&
            firstChild.mediaUrl
          ) {
            slideContent = `
              <a href="${item.permalink}" target="_blank">
                <img src="${firstChild.mediaUrl}" alt="${item.caption}" />
              </a>
            `;
          } else if (
            firstChild &&
            firstChild.mediaType === "VIDEO" &&
            firstChild.thumbnailUrl &&
            firstChild.mediaUrl
          ) {
            slideContent = `
              <a href="${item.permalink}" target="_blank">
                <video poster="${firstChild.thumbnailUrl}" muted loop>
                  <source src="${firstChild.mediaUrl}" type="video/mp4">
                </video>
              </a>
            `;
          }
        } else if (
          item.mediaType === "VIDEO" &&
          item.thumbnailUrl &&
          item.mediaUrl
        ) {
          slideContent = `
            <a href="${item.permalink}" target="_blank">
              <video poster="${item.thumbnailUrl}" muted loop>
                <source src="${item.mediaUrl}" type="video/mp4">
              </video>
            </a>
          `;
        }

        if (slideContent) {
          carouselItems += `<div class="instaContent">${slideContent}</div>`;
        }
      });

      if (instaElement) {
        instaElement.innerHTML = carouselItems;
      }

      // Function to initialize the slick slider with the specified slidesToShow value
      function initSlickSlider(slidesToShow) {
        $(instaElement).slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          infinite: false,
          prevArrow: false, // Disable prev arrow
          nextArrow: false, // Disable next arrow
        });
      }

      // Function to destroy the slick slider instance
      function destroySlickSlider() {
        if ($(instaElement).hasClass("slick-initialized")) {
          $(instaElement).slick("unslick");
        }
      }

      // Function to handle slider initialization based on screen size
      function handleSliderInitialization() {
        if (data.length >= 6) {
          destroySlickSlider();
          initSlickSlider(6);
        } else if (window.innerWidth <= 768) {
          destroySlickSlider();
          initSlickSlider(2);
        } else {
          destroySlickSlider();
        }
      }

      // Call the handleSliderInitialization function to initialize the slick slider
      handleSliderInitialization();

      $(".prev-btn-insta").click(function () {
        $("#insta").slick("slickPrev");
      });

      $(".next-btn-insta").click(function () {
        $("#insta").slick("slickNext");
      });
      $(".prev-btn-insta").addClass("slick-disabled");
      $("#insta").on("afterChange", function () {
        if ($(".slick-prev").hasClass("slick-disabled")) {
          $(".prev-btn-insta").addClass("slick-disabled");
        } else {
          $(".prev-btn-insta").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
          $(".next-btn-insta").addClass("slick-disabled");
        } else {
          $(".next-btn-insta").removeClass("slick-disabled");
        }
      });

      // Add hover event listener to the video elements
      $(instaElement).on("mouseenter", "video", function () {
        this.play(); // Play the video on hover
      });

      $(instaElement).on("mouseleave", "video", function () {
        this.pause(); // Pause the video when the hover ends
      });

      // Event listener for window resize
      $(window).on("resize", function () {
        handleSliderInitialization();
      });
    })
    .catch((error) => console.error(error));

  //contact form
  if (document.getElementById("contactForm")) {
    const contactForm = document.getElementById("contactForm");
    const submitButton = document.getElementById("submitButton");
    const checkboxInput = document.getElementById("checkboxForm");

    $("#checkboxForm").change(function () {
      if (this.checked) {
        console.log("yes");
      } else {
        console.log("no");
      }
    });

    submitButton.addEventListener("click", (event) => {
      event.preventDefault();

      const loaderElement = document.querySelector(".loader");
      loaderElement.classList.add("active");

      const formData = new FormData(contactForm);
      const formValues = {};

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      if (checkboxInput.checked) {
        console.log("yes");
        $.ajax({
          url: "/api/form/contact/submit",
          type: "POST",
          data: JSON.stringify(formValues),
          contentType: "application/json",
          success: function (response) {
            console.log(response);
            document.getElementById("responseMessageName").innerHTML = "";
            document.getElementById("responseMessageEmail").innerHTML = "";
            document.getElementById("responseMessageTel").innerHTML = "";
            document.getElementById("responseMessageOrg").innerHTML = "";
            document.getElementById("responseMessageMsg").innerHTML = "";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="success">' + response.message + "</div>";
            loaderElement.classList.remove("active");
          },
          error: function (error) {
            console.error(error);

            // Parse the error response as JSON
            const errorResponse = JSON.parse(error.responseText);

            // Display the error messages for each field
            if (errorResponse.errors.name) {
              document.getElementById("responseMessageName").innerHTML =
                '<div class="error">' + errorResponse.errors.name[0] + "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error">' + "Vul alle velden juist in." + "</div>";
            } else {
              document.getElementById("responseMessageName").innerHTML = "";
            }

            if (errorResponse.errors.email) {
              document.getElementById("responseMessageEmail").innerHTML =
                '<div class="error">' +
                errorResponse.errors.email[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error">' + "Vul alle velden juist in." + "</div>";
            } else {
              document.getElementById("responseMessageEmail").innerHTML = "";
            }

            if (errorResponse.errors.phone_number) {
              document.getElementById("responseMessageTel").innerHTML =
                '<div class="error">' +
                errorResponse.errors.phone_number[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error">' + "Vul alle velden juist in." + "</div>";
            } else {
              document.getElementById("responseMessageTel").innerHTML = "";
            }

            if (errorResponse.errors.organisation) {
              document.getElementById("responseMessageOrg").innerHTML =
                '<div class="error">' +
                errorResponse.errors.organisation[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error">' + "Vul alle velden juist in." + "</div>";
            } else {
              document.getElementById("responseMessageOrg").innerHTML = "";
            }

            if (errorResponse.errors.message) {
              document.getElementById("responseMessageMsg").innerHTML =
                '<div class="error">' +
                errorResponse.errors.message[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error">' + "Vul alle velden juist in." + "</div>";
            } else {
              document.getElementById("responseMessageMsg").innerHTML = "";
            }
            loaderElement.classList.remove("active");
          },
        });
      } else {
        console.log("no");
        document.getElementById("responseSuccess").innerHTML =
          '<div class="error">' +
          "Ga akkoord met de privacy policy." +
          "</div>";
        loaderElement.classList.remove("active");
      }

      console.log(formValues);
    });
  }

  //js
});
